import React from 'react';

import circle from '../../../../assets/images/Ellipse1394.svg';
import building from '../../../../assets/images/tabler-icon-building-skyscraper.svg';

import styles from './DepartmentIcon.module.scss';

const DepartmentIcon = ({ departmentContainer }) => (
  <div className={departmentContainer}>
    <img src={circle} alt="vector" className={styles.ellipseIcon} />
    <div className={styles.buildingIconDiv}>
      <img src={building} alt="building" className={styles.buildingIcon} />
    </div>
  </div>
);
export default DepartmentIcon;
